import React, { useEffect, useState,useContext,useRef } from "react";



import { Box, VStack, Wrap, WrapItem } from "@chakra-ui/react";
import {

    SimpleGrid,
    Button,
    useDisclosure,
    Drawer,
    DrawerContent,
    DrawerOverlay,
    DrawerCloseButton,
    DrawerHeader,
    DrawerBody,
    FormControl,
    FormLabel,
    Input,
    DrawerFooter,
} from "@chakra-ui/react";
import axios from "axios";
import { useParams } from "react-router-dom";
import FamilyCard from "./FamilyCard";
import AdminLogin from "../../AdminNav/Login";
import { MyContext } from "../../../MyProvider";

import { Ledger, LoadingState, PageHeader, Pagination } from "../../../components/ui";
import { API_URL } from "../../../Apis/config";

function Family() {
    const {userData,userApi}=useContext(MyContext);
    const {id} = useParams();
    const [appointments, setAppointments] = useState([]);//[]
    // const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [appointmentsPerPage] = useState(8);
    const [totalusers, setTotalUsers] = useState(0);
    // const [update, setUpdate] = useState(false);
    
    
    const [user,setUser]=useState("");//{}
    const { isOpen, onOpen, onClose } = useDisclosure();
    const initialRef = useRef(null);
    const finalRef = useRef(null);
    const [formData, setFormData] = useState({});
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "DOB") {
            // Reformat the date value to "dd/mm/yyyy"
            const [year, month, day] = value.split("-");
            const formattedDate = `${day}/${month}/${year}`;
            //   console.log(value)
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: formattedDate,
            }));
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
            }));
        }
        // console.log(formData)
    };
    useEffect(()=>{
        const singleUser=userData.filter((ele)=>ele._id==id)[0];
        if(!singleUser)return;
        setUser(singleUser);
        setTotalUsers(singleUser.family.length);
        setAppointments(singleUser.family);
    },[userData,id])
    
      

    const deleteClick=async()=>{
        await userApi();
    };



    // Get current appointments based on pagination
    const indexOfLastAppointment = currentPage * appointmentsPerPage;
    const indexOfFirstAppointment = indexOfLastAppointment - appointmentsPerPage;
    const currentAppointments = appointments.slice(
        indexOfFirstAppointment,
        indexOfLastAppointment
    );
// console.log(currentAppointments,user)
    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prevPage) => prevPage - 1);
        }
    };
    const goToNextPage = () => {
        if (currentPage < Math.ceil(appointments.length / appointmentsPerPage)) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    const token = localStorage.getItem("AdminToken");
  if (!token) {
    return <AdminLogin />;
  }

    const updateClick = (appointmentStatus, familyId) => {
        axios
            .patch(`${API_URL}/users/${id}/family/${familyId}`,
appointmentStatus)
            .then((res) => 
            
            userApi()
            )
            .catch((err) => console.log(err));
    };
    const addClick = () => {
        axios
            .post(`${API_URL}/users/${id}/family`,
formData)
            .then((res) => 
            
            userApi()
            )
            .catch((err) => console.log(err));
    };
    if (!user) {
        return <LoadingState>Loading family details</LoadingState>;
    }
    return (
        <>
            <PageHeader title={`${user.fname} family`} subtitle={`${totalusers} recorded`}>
                <Button onClick={onOpen}>Add family</Button>
            </PageHeader>
            <Ledger
                columns="minmax(0,1fr) minmax(0,1.4fr) minmax(0,1fr) 170px"
                heads={["Relation", "Name", "Nakshatram", ""]}
                isEmpty={appointments.length === 0}
                emptyText="No family members recorded yet. Add the first one."
            >
                {currentAppointments.map((apt) => (
                    <FamilyCard key={apt._id} User={apt} updateClick={updateClick} deleteClick={deleteClick} />
                ))}
            </Ledger>
            <Pagination
                currentPage={currentPage}
                pageCount={Math.ceil(appointments.length / appointmentsPerPage)}
                onPrevious={goToPreviousPage}
                onNext={goToNextPage}
                onPage={paginate}
            />
            <Drawer size="md"
                initialFocusRef={initialRef}
                finalFocusRef={finalRef}
                isOpen={isOpen}
                onClose={onClose}
            >
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerHeader>Add Users Family</DrawerHeader>
                    <DrawerCloseButton />
                    <DrawerBody pb={6}>
                        <FormControl>
                            <FormLabel>Full Name</FormLabel>
                            <Input
                                type="text"
                                name="Name"
                                ref={initialRef}
                                onChange={handleInputChange}
                                placeholder="Full Name"
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Relation</FormLabel>
                            <Input
                                type="text"
                                name="Relation"
                               
                                onChange={handleInputChange}
                                placeholder="Relation"
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Nakshatram</FormLabel>
                            <Input
                                type="text"
                                name="Nakshatram"
                                
                                onChange={handleInputChange}
                                placeholder="Nakshatram"
                            />
                        </FormControl>
                    </DrawerBody>

                    <DrawerFooter>
                        <Button
                            mr={3}
                            isDisabled={!formData.Name || !formData.Relation}
                            onClick={() =>{ 
                                addClick()
                                onClose()}}
                        >
                            Save
                        </Button>
                        <Button variant="ghost" onClick={onClose}>Cancel</Button>
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>
        </>
    );
}

export default Family;
